export enum OrderType {
    Market,
    Limit,
}

export enum Type {
    Long,
    Short,
}

export type ModeType = 'LITE' | 'PRO';

export interface FormValue {
    orderType: OrderType;
    leverage: number;
    limitPrice: string;
    pairIndex: string;
    amount: string;
    mode?: ModeType;
    type: Type;
    tp: string;
    sl: string;
    unit?: 'USD' | 'PERCENTAGE';
}

export type TradeStruct = {
    trader: string;
    pairIndex: string;
    index: string;
    initialPosToken: string;
    positionSizeUsdc: string;
    openPrice: string;
    buy: boolean;
    leverage: string;
    tp: string;
    sl: string;
};
